export default __webpack_public_path__ + "static/media/46.24ce3eb7.jpg";